export enum ImagePositionOnPage {
  IMAGE_LEFT_OF_QUESTION = 'IMAGE_LEFT_OF_QUESTION',
  IMAGE_BENEATH_QUESTION = 'IMAGE_BENEATH_QUESTION',
  IMAGE_IN_SIDE_PANE = 'IMAGE_IN_SIDE_PANE',
  IMAGES_IN_SLIDES = 'IMAGES_IN_SLIDES',
}
